import script from "./PlaylistCollectionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaylistCollectionCard.vue?vue&type=script&setup=true&lang=js"

import "./PlaylistCollectionCard.vue?vue&type=style&index=0&id=53ceb771&lang=css"

const __exports__ = script;

export default __exports__